// src/components/inventory/IngredientesTable.js
import React from 'react';
import TablaInventario from './TablaInventario';

const COLUMNAS = [
  { clave: 'ingredient_id', etiqueta: 'ID', tipo: 'lectura', enCreacion: false },
  { clave: 'name', etiqueta: 'Ingrediente', tipo: 'texto', requerido: true, placeholder: 'Ej. Queso costeño' },
  { clave: 'stock_current', etiqueta: 'Existencias', tipo: 'numero', alinear: 'derecha', placeholder: '0' },
  { clave: 'stock_minimum', etiqueta: 'Mínimo', tipo: 'numero', alinear: 'derecha', placeholder: '0' },
];

// El estado sale de comparar existencias contra el mínimo de cada registro.
const estadoFila = (i) => {
  const actual = parseFloat(i.stock_current);
  const minimo = parseFloat(i.stock_minimum);
  if (actual <= 0) return { tono: 'peligro', texto: 'Agotado' };
  if (actual < minimo) return { tono: 'aviso', texto: 'Bajo el mínimo' };
  return { tono: 'exito', texto: 'Disponible' };
};

function IngredientesTable({ isReadOnly }) {
  return (
    <TablaInventario
      titulo="Ingredientes"
      descripcion="Lo que se descuenta al vender un producto."
      recurso="/api/ingredientes"
      idKey="ingredient_id"
      columnas={COLUMNAS}
      estadoFila={estadoFila}
      etiquetaBuscar="Buscar ingrediente…"
      nuevoVacio={{ name: '', stock_current: '', stock_minimum: '' }}
      // El backend espera los ingredientes envueltos en un arreglo.
      aPayloadCrear={(n) => ({
        ingredientes: [{
          name: n.name.trim(),
          stock_current: Number(n.stock_current) || 0,
          stock_minimum: Number(n.stock_minimum) || 0,
        }],
      })}
      isReadOnly={isReadOnly}
    />
  );
}

export default IngredientesTable;
